import { enableScroll, disableScroll } from "./helpers";

export default function Modal() {
  let open;
  let button;
  let modal;
  let closeBtn;

  const init = (modalElement) => {
    modal = modalElement;
    initDefaults();
    initEvents();
  };

  const initEvents = () => {
    openModalOnButtonClick();
    closeModalOnButtonClick();
    closeModalOnEscapeClick();
    closeModalOnInnerButtonClick();
  };

  const closeModalOnInnerButtonClick = () => {
    const innerButtons = modal.querySelectorAll("a.closable, button.closable");
    innerButtons.forEach((el) => {
      el.addEventListener("click", (e) => {
        closeModal();
      });
    });
  };

  const openModalOnButtonClick = () => {
    button.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        open ? closeModal() : openModal();
      });
    });
  };

  const closeModalOnButtonClick = () => {
    closeBtn.addEventListener("click", (e) => {
      closeModal();
    });
  };

  const closeModalOnEscapeClick = () => {
    document.addEventListener("keydown", (e) => {
      e.key === "Escape" && open && closeModal();
    });
  };

  const initDefaults = () => {
    closeBtn = modal.querySelector(".btn-close");
    button = document.querySelectorAll(`[href='${modal.dataset.target}']`);
  };

  const openModal = () => {
    disableScroll();
    modal.classList.add("open");
    open = true;
  };

  const closeModal = () => {
    enableScroll();
    modal.classList.remove("open");
    open = false;
  };

  return {
    init,
  };
}
